import { useState } from 'react'

import Button from 'common/components/button/Button'
import ContentTypeBubble from 'common/components/ContentTypeBubble'
import ToggleButtonGroup from 'common/components/toggleButtonGroup'
import { useAppDispatch } from 'common/hooks/redux'
import { Close as CloseIcon } from 'common/icons'
import { TemplateInfo } from 'features/unifiedFlow/contentsPage/interfaces'
import { removeTemplate } from 'features/unifiedFlow/store/unifiedFlowSlice'

import ToggleButtonGroupTabs from './ToggleButtonGroupTabs'

type templateToAddProps = {
  template: TemplateInfo
}

const AddedComponentCard = ({ template }: templateToAddProps) => {
  const dispatch = useAppDispatch()
  const [tabToShow, setTabToShow] = useState<string | undefined>(undefined)

  const handleToggleGroupClick = (name) => {
    setTabToShow(name)
  }

  const { id, icon, optimization, personalization, displayName } = template

  const items = [
    {
      name: 'content',
      disabled: false,
    },
    ...(optimization !== 'disabled'
      ? [
          {
            name: 'optimize',
            disabled: optimization === 'blocked',
            tooltipMessage: 'Talk to us about upgrading',
          },
        ]
      : []),
    ...(personalization !== 'disabled'
      ? [
          {
            name: 'personalize',
            disabled: personalization === 'blocked',
            tooltipMessage: 'Talk to us about upgrading',
          },
        ]
      : []),
  ]

  return (
    <div className="bg-white flex flex-col rounded-md p-6 border border-coolGray-300 mb-4 last:mb-0">
      <div className="flex items-center mb-4">
        <ContentTypeBubble name={displayName} iconType={icon} />
        <div className="text-base font-medium flex ml-4 text-coolGray-800">
          {displayName}
        </div>
        <div className="flex ml-auto">
          <Button
            onClick={() => {
              dispatch(removeTemplate({ templateId: id }))
            }}
            className="px-0 ml-4 h-4"
            variant="icon"
            aria-label="close"
          >
            <CloseIcon className="text-coolGray-400" state="default" size={4} />
          </Button>
        </div>
      </div>
      <ToggleButtonGroup
        items={items}
        onChange={handleToggleGroupClick}
        className="capitalize"
      />
      <ToggleButtonGroupTabs tabToShow={tabToShow} template={template} />
    </div>
  )
}

export default AddedComponentCard
